import styled from 'styled-components';

const RuleBuilderWrapper = styled.div`
  padding-top: ${(props): string => props.theme.spaces.lg};
  padding-bottom: ${(props): string => props.theme.spaces.lg};
`;

export { RuleBuilderWrapper };
